export const HIRE_FREELANCER_GET_REQUEST = "HIRE_FREELANCER_GET_REQUEST";
export const HIRE_FREELANCER_GET_SUCCESS = "HIRE_FREELANCER_GET_SUCCESS";
export const HIRE_FREELANCER_GET_FAIL = "HIRE_FREELANCER_GET_FAIL";
export const MY_JOB_LIST_GET_REQUEST = "MY_JOB_LIST_GET_REQUEST";
export const MY_JOB_LIST_GET_SUCCESS = "MY_JOB_LIST_GET_SUCCESS";
export const MY_JOB_LIST_GET_FAIL = "MY_JOB_LIST_GET_FAIL";
export const CREATE_JOB_RIGHT_SIDE_REQUEST = "CREATE_JOB_RIGHT_SIDE_REQUEST";
export const CREATE_JOB_RIGHT_SIDE_SUCCESS = "CREATE_JOB_RIGHT_SIDE_SUCCESS";
export const CREATE_JOB_RIGHT_SIDE_FAIL = "CREATE_JOB_RIGHT_SIDE_FAIL";
